import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.notice.list');
import { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcuser-notice-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.notice.list/view.scss */
/* src/app/portal.gsdcuser.notice.list/view.scss: no such file or directory */`],
})
export class PortalGsdcuserNoticeListComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public boards: any = [];
    public pagination: any = { page: 1, end: 1, start: 1 };
    public total: any = 0;
    public mode: string = '';
    public searchTerm: string = '';
    private requestVersion = 0;
    private stateKey: string;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, '/login');
        this.stateKey = 'gsdc.notice.list.' + this.service.auth.session.id;
        this.restoreState();
        await this.load();
    }

    public ngOnDestroy() { this.requestVersion++; }

    private restoreState() {
        const params = new URL(window.location.href).searchParams;
        let state: any = {};
        if (['q', 'mode', 'page'].some(key => params.has(key))) {
            state = { text: params.get('q'), mode: params.get('mode'), page: params.get('page') };
        } else {
            try { state = JSON.parse(sessionStorage.getItem(this.stateKey) || '{}') || {}; } catch (_) { }
        }
        this.searchTerm = typeof state.text === 'string' ? state.text : '';
        this.mode = ['public', 'community'].includes(state.mode) ? state.mode : '';
        const page = Number(state.page);
        this.pagination.page = Number.isSafeInteger(page) && page > 0 ? page : 1;
    }

    private async rememberState() {
        const state = { text: this.searchTerm, mode: this.mode, page: this.pagination.page };
        try { sessionStorage.setItem(this.stateKey, JSON.stringify(state)); } catch (_) { }
        const params = new URLSearchParams({ q: state.text, mode: state.mode, page: String(state.page) });
        await this.router.navigateByUrl('/notice?' + params.toString(), { replaceUrl: true });
    }

    public async load() {
        const version = ++this.requestVersion;
        const { code, data } = await wiz.call('load', { text: this.searchTerm, page: this.pagination.page, mode: this.mode });
        // A slow earlier search must not replace newer results or saved state.
        if (version !== this.requestVersion) return;
        if (code != 200) return await this.service.alert.error('Error!');
        this.boards = data.rows;
        if (data.page) this.pagination.page = data.page;
        this.pagination.start = Math.floor((this.pagination.page - 1) / 10) * 10 + 1;
        this.pagination.end = data.lastpage;
        this.total = data.total;
        await this.rememberState();
        await this.service.render();
    }

    public async pageLoad(page: number) {
        this.pagination.page = page;
        await this.load();
    }

    public async clearSearch() {
        this.searchTerm = '';
        document.getElementById('notice-search')?.focus();
        await this.pageLoad(1);
    }
}

export default PortalGsdcuserNoticeListComponent;